//here most common logic, but each play-box component still has some logic according to multiplayer
import ModalFrameForIndividualSettings from '../../components/trainer/games/ModalFrameForIndividualSettings.vue';

const SECONDS_IN_MINUTE = 60;

function DEFAULT_DATA() {
    return {
        individualParametersChangerCounter: 0,
        showModalFrame: false,
        isGamePaused: false,
        counter: null,
    };
}

export default {
    props: {
        place: {
            type: Number,
            default: 0,
        },
        playersNumber: {
            type: Number,
            default: 0,
        },
        checkMultiplayerAnswers: {
            type: Boolean,
            default: false,
        },
        multiplayerGamesState: {
            type: String,
            default: '',
        },
        colorForStudent: {
            type: String,
            default: '',
        },
        refreshGameEvent: {
            type: Boolean,
            default: false,
        },
        continueGameEvent: {
            type: Boolean,
            default: false,
        },
        commonParametersChangerCounter: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return DEFAULT_DATA();
    },
    methods: {
        handleParametersUpdate() {
            this.individualParametersChangerCounter += 1;
        },
    },
    computed: {
        parametersChangerCounter() {
            return this.commonParametersChangerCounter + this.individualParametersChangerCounter;
        },
        isAvailableExamplesToSolveAndTimeLimit() {
            return (
                (this.parameters.amountOfExamples && this.answers.good < this.parameters.amountOfExamples) ||
                (this.parameters.timeLimit && this.time < this.parameters.timeLimit * SECONDS_IN_MINUTE) ||
                (!this.parameters.timeLimit && this.parameters.infinityAmountOfExamples)
            );
        },
    },
    components: {
        ModalFrameForIndividualSettings,
    },
};
